/**
 * Prefix → i18n key, most specific first.
 * `/settings` and `/account` (and their `:slug`s) are handled in resolveRouteTitleKey
 * (settingSections / ACCOUNT_NAV titles).
 */
export const routeTitleRules: ReadonlyArray<{ prefix: string; titleKey: string }> = [
  { prefix: '/files/personal', titleKey: 'pageTitle.filesPersonal' },
  { prefix: '/files/received', titleKey: 'pageTitle.filesReceived' },
  { prefix: '/files/shared', titleKey: 'pageTitle.filesShared' },
  { prefix: '/files/favorites', titleKey: 'pageTitle.filesFavorites' },
  { prefix: '/files/recent', titleKey: 'pageTitle.filesRecent' },
  { prefix: '/files/hidden', titleKey: 'pageTitle.filesHidden' },
  { prefix: '/files/trash', titleKey: 'pageTitle.filesTrash' },
  { prefix: '/files/public', titleKey: 'pageTitle.publicLink' },
  { prefix: '/emails/inbox', titleKey: 'pageTitle.emailsInbox' },
  { prefix: '/emails/sent', titleKey: 'pageTitle.emailsSent' },
  { prefix: '/emails/drafts', titleKey: 'pageTitle.emailsDrafts' },
  { prefix: '/emails/favorites', titleKey: 'pageTitle.emailsFavorites' },
  { prefix: '/emails/archive', titleKey: 'pageTitle.emailsArchive' },
  { prefix: '/emails/trash', titleKey: 'pageTitle.emailsTrash' },
  { prefix: '/emails', titleKey: 'pageTitle.emails' },
  { prefix: '/file-share-requests', titleKey: 'pageTitle.fileShareRequests' },
  { prefix: '/file/protected', titleKey: 'pageTitle.protectedFile' },
  { prefix: '/sales-dashboard', titleKey: 'pageTitle.salesDashboard' },
  { prefix: '/activity-logs', titleKey: 'pageTitle.activityLogs' },
  { prefix: '/antivirus-quarantine', titleKey: 'pageTitle.antivirusQuarantine' },
  { prefix: '/sharepoint', titleKey: 'pageTitle.sharePointStatus' },
  { prefix: '/quick-share', titleKey: 'pageTitle.quickShare' },
  { prefix: '/payment/success', titleKey: 'pageTitle.paymentSuccess' },
  { prefix: '/dashboard', titleKey: 'pageTitle.dashboard' },
  { prefix: '/users', titleKey: 'pageTitle.users' },
  { prefix: '/groups', titleKey: 'pageTitle.groups' },
  { prefix: '/viewer', titleKey: 'pageTitle.viewer' },
  { prefix: '/document', titleKey: 'pageTitle.office' },
  { prefix: '/spreadsheet', titleKey: 'pageTitle.office' },
  { prefix: '/presentation', titleKey: 'pageTitle.office' },
  { prefix: '/wopitest', titleKey: 'pageTitle.office' },
  { prefix: '/store', titleKey: 'pageTitle.store' },
  { prefix: '/purchase', titleKey: 'pageTitle.purchase' },
  { prefix: '/login', titleKey: 'pageTitle.login' },
  { prefix: '/logout', titleKey: 'pageTitle.logout' },
  { prefix: '/extension/authorize', titleKey: 'pageTitle.extensionAuthorize' },
  { prefix: '/oauth', titleKey: 'pageTitle.login' },
];

export const FALLBACK_ROUTE_TITLE_KEY = 'pageTitle.app';
